<template>
  <div>
    <Layout>
      <div class="bg-gray-200 shadow mb-16">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-700">
            Use your own write key
          </h3>
        </div>
        <div class=" p-5">
          <form action="/custom" method="GET">
            <label class="form-label" for="segment-write-key">Enter your Segment Write Key</label>
            <div class="flex-col md:flex">
              <input type="text" id="segment-write-key" name="key" class="form-input w-full mb-2 mr-2">
              <button class="w-full bg-gray-600 hover:bg-gray-800 text-white px-4 rounded flex-none xl:flex-1 py-2" type="submit">Load Segment Tester</button>
            </div>
          </form>
        </div>
      </div>
      <div class="bg-gray-200 shadow overflow-hidden sm:rounded-md mb-16">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-700">
            QC Environment
          </h3>
        </div>
        <ul>
          <li>
            <a href="/qc-email" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
              <div class="px-4 py-4 flex items-center sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <div class="text-sm leading-5 font-medium text-blue-600 truncate">
                      Email as primary key
                    </div>
                    <div class="mt-2 flex">
                      <div class="flex items-center text-sm leading-5 text-gray-500">
                        <svg class="flex-shrink-0 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                        </svg>
                        <span>
                          Account 11
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                </div>
              </div>
            </a>
          </li>

          <li class="border-t border-gray-100">
            <a href="/qc-cid" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
              <div class="px-4 py-4 flex items-center sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <div class="text-sm leading-5 font-medium text-blue-600 truncate">
                        cID as primary key
                    </div>
                    <div class="mt-2 flex">
                      <div class="flex items-center text-sm leading-5 text-gray-500">
                        <svg class="flex-shrink-0 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                        </svg>
                        <span>
                          Account 41
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div class="bg-gray-200 shadow overflow-hidden sm:rounded-md">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <h3 class="text-lg leading-6 font-medium text-gray-600">
            Staging Environment
          </h3>
        </div>
        <ul>
          <li class="border-t border-gray-100">
            <a href="/stg-email" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
              <div class="px-4 py-4 flex items-center sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <div class="text-sm leading-5 font-medium text-blue-600 truncate">
                      Email as primary key
                    </div>
                    <div class="mt-2 flex">
                      <div class="flex items-center text-sm leading-5 text-gray-500">
                        <svg class="flex-shrink-0 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                        </svg>
                        <span>
                          Account 99104
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                </div>
              </div>
            </a>
          </li>

          <li class="border-t border-gray-100">
            <a href="/qc-cid" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
              <div class="px-4 py-4 flex items-center sm:px-6">
                <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <div class="text-sm leading-5 font-medium text-blue-600 truncate">
                      cID as primary key
                    </div>
                    <div class="mt-2 flex">
                      <div class="flex items-center text-sm leading-5 text-gray-500">
                        <svg class="flex-shrink-0 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                        </svg>
                        <span>
                          Account 99126
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ml-5 flex-shrink-0">
                  <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <div class="bg-gray-200 shadow p-5 my-5">
        <h1 class="px-2 py-1 text-xs font-bold bg-red-300 inline-block">Coming Soon</h1>
        <h3 class="text-2xl text-gray-300">PROD</h3>
        <ul class="text-gray-300">
          <li><span class="font-bold">Account 132</span> is set up with <span class="bg-yellow-100 px-2 py-1">email</span> as primary key</li>
          <li><span class="font-bold">Account 99126</span> is set up with <span class="bg-yellow-100 px-2 py-1">cID</span> as primary key</li>
        </ul>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from './components/Layout.vue'

export default {
  name: 'app',
  components: {
    Layout
  },
}
</script>
